import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { AppThemeProvider } from './theme/AppThemeProvider';
import { router } from './routes/router';

// O AuthProvider (sessão administrativa) vive dentro do roteador, só em volta
// do login e do painel: a área do organizador não consulta /api/auth/me.
export default function App() {
  return (
    <AppThemeProvider>
      <RouterProvider router={router} />
      <ToastContainer newestOnTop theme="colored" />
    </AppThemeProvider>
  );
}
